"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _RoundedButton = _interopRequireDefault(require("../Buttons/RoundedButton"));

var _IconActionChevronRight = _interopRequireDefault(require("../Icons/IconActionChevronRight"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ProspectInfoBar = function ProspectInfoBar(_ref) {
  var icon = _ref.icon,
      children = _ref.children,
      onClick = _ref.onClick,
      rest = _objectWithoutProperties(_ref, ["icon", "children", "onClick"]);

  return /*#__PURE__*/_react.default.createElement(Bar, rest, icon ? /*#__PURE__*/_react.default.createElement(BarIcon, null, icon) : null, /*#__PURE__*/_react.default.createElement(BarContent, null, children), /*#__PURE__*/_react.default.createElement(BarButton, null, onClick ? /*#__PURE__*/_react.default.createElement(_RoundedButton.default, {
    icon: /*#__PURE__*/_react.default.createElement(_IconActionChevronRight.default, {
      size: 20
    }),
    onClick: onClick
  }) : null));
};

var Bar = _styledComponents.default.div.withConfig({
  displayName: "Bar"
})(["width:100%;max-width:100rem;background-color:white;border:1px solid #e4e4e4;box-sizing:border-box;box-shadow:0 2px 4px rgba(32,32,35,0.1);border-radius:4px;display:flex;justify-content:space-between;"]);

var BarIcon = _styledComponents.default.div.withConfig({
  displayName: "BarIcon"
})(["display:flex;justify-content:center;align-items:center;border-right:1px solid #e4e4e4;padding:2rem;svg path{fill:", ";}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.ui.disabled;
});

var BarContent = _styledComponents.default.div.withConfig({
  displayName: "BarContent"
})(["width:100%;display:grid;grid-template-columns:repeat(4,auto);row-gap:1.5rem;column-gap:3rem;align-items:center;padding:1.5rem 3rem;@media screen and (max-width:900px){grid-template-columns:repeat(2,1fr);}@media screen and (max-width:600px){grid-template-columns:repeat(1,1fr);}"]);

var BarButton = _styledComponents.default.div.withConfig({
  displayName: "BarButton"
})(["margin-right:2rem;display:flex;justify-content:center;align-items:center;"]);

ProspectInfoBar.propTypes = {
  /** Pass an icon as element to be displayed at the front of the bar. */
  icon: _propTypes.element,

  /** Children to be displayed in the center of the bar. */
  children: _propTypes.node.isRequired,

  /** Passing no function will result in the right arrow not being shown. */
  onClick: _propTypes.func
};
var _default = ProspectInfoBar;
exports.default = _default;